import React from 'react';
import { CheckCircle2Icon, LayoutGridIcon, MessageCircleIcon, TruckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { useLanguage } from '../../contexts/LanguageContext';
const icons = [MessageCircleIcon, LayoutGridIcon, CheckCircle2Icon, TruckIcon];
export function ProcessSteps({
  layout
}: {
  layout: 'row' | 'column';
}) {
  const {
    t
  } = useLanguage();
  const p = t.process;
  if (layout === 'row') {
    return <ol className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6" data-id="element-364" data-mp="2v7lyrt60wge0">
        {p.steps.map((step, i) => {
        const Icon = icons[i];
        return <li key={step.title} className="h-full" data-id="element-365" data-mp="3480od4q0shnb" data-mpi={i}>
              <Reveal delay={0.04 * i} className="relative flex h-full flex-col border-t-2 border-mauve/20 pt-6" data-id="element-366" data-mp="345o069to5b1t">
                <span className="absolute -top-[5px] left-0 h-2 w-12 rounded-full bg-mauve" aria-hidden="true" data-id="element-367" data-mp="jhjcrdjzgs2r" />
                <div className="flex items-center justify-between" data-id="element-368" data-mp="fg7ujt3fv94l">
                  <Icon className="h-6 w-6 text-mauve" aria-hidden="true" data-id="element-369" data-mp="fi0www70r76s" />
                  <span className="text-xs font-medium uppercase tracking-wider2 text-ink/50" data-id="element-370" data-mp="2inpnkaylpcx5">
                    {p.stepLabel} 0{i + 1}
                  </span>
                </div>
                <h3 className="mt-4 font-display text-xl font-semibold text-ink" data-id="element-371" data-mp="2rq7c4w1qahnb">{step.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-ink/70" data-id="element-372" data-mp="2wmxnj62l8p2e">{step.text}</p>
              </Reveal>
            </li>;
      })}
      </ol>;
  }
  return <ol className="border-l border-mauve/25" data-id="element-373" data-mp="23ytkksbeiq3e">
      {p.steps.map((step, i) => {
      const Icon = icons[i];
      return <li key={step.title} className="relative pb-12 pl-10 last:pb-0" data-id="element-374" data-mp="28xmp3v8pn6rf" data-mpi={i}>
            <Reveal delay={0.04 * i} data-id="element-375" data-mp="2dpedq08b32ex">
              <span className="absolute -left-5 top-0 flex h-10 w-10 items-center justify-center rounded-full border border-mauve/25 bg-white" aria-hidden="true" data-id="element-376" data-mp="2dqfsofsg091x">
                <Icon className="h-5 w-5 text-mauve" data-id="element-377" data-mp="1l6qxay498bk6" />
              </span>
              <p className="pt-2 text-xs font-medium uppercase tracking-wider2 text-mauve" data-id="element-378" data-mp="2oi6eymqg281k">
                {p.stepLabel} 0{i + 1}
              </p>
              <h3 className="mt-2 font-display text-2xl font-semibold text-ink" data-id="element-379" data-mp="2xbt9yamtv79p">{step.title}</h3>
              <p className="mt-3 max-w-lg text-[15px] leading-relaxed text-ink/70" data-id="element-380" data-mp="2tapsxkt1n56w">{step.text}</p>
            </Reveal>
          </li>;
    })}
    </ol>;
}